import React from "react";
import { ValueType } from "react-select/src/types";

import {
    SCHEDULED_JOB_SCRIPT_TYPE_LABELS,
    SCHEDULED_JOB_SCRIPT_TYPES,
    ScheduledJobScriptType,
} from "../../../../enums/ScheduledJobScriptType";
import { DialogSelect } from "../../../shared/dialogSelect";

interface Option { value: string; label: string; }

const OPTIONS: Option[] = SCHEDULED_JOB_SCRIPT_TYPES.map(it => ({
    label: SCHEDULED_JOB_SCRIPT_TYPE_LABELS[it],
    value: it.toString(),
}));

interface Props {
    selectedScriptType: ScheduledJobScriptType;
    onScriptTypeChange: (type: ScheduledJobScriptType) => void;
}

export function ScheduledJobScriptTypeSelector({ selectedScriptType, onScriptTypeChange }: Props) {
    const handleChange = (
        selected: ValueType<Option>
    ) => {
        const option = selected as Option;
        if (!option) return;
        onScriptTypeChange(option.value as ScheduledJobScriptType);
    }

    return (
        <DialogSelect
            options={OPTIONS}
            value={OPTIONS.find(it => it.value === selectedScriptType)}
            onChange={handleChange}
        />
    );
}
